import { useNavigate } from "react-router-dom";
import { getSuccessToast, getWarningToast } from "../../../toast";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { ReactSession } from "react-client-session";

const RecoHeaderButton = ({
    fileURL,
    setIsLoading,
    getExtension,
    disabledState
}) => {

    const navigate = useNavigate()
    const axiosPrivate = useAxiosPrivate()
    const box_id = ReactSession.get('box_id')
    const role = ReactSession.get('role')

    const AnotherMethod = () => {
        setIsLoading(true);
        const formdata = new FormData();
        formdata.append("gpt", false);
        formdata.append("reco_file_url", fileURL);
        axiosPrivate
            .post(`reconcilation/reconcilation/${box_id}`, formdata)
            .then((res) => {
                if (res.status === 200) {
                    getSuccessToast('New method is applyed.')
                    if(role === "3"){
                        navigate("/scan")
                        return
                    }
                    navigate('/')
                }
            })
            .catch((err) => {
                console.log(err);
                getWarningToast('Please try a different document or check if the PDF is readable and of good quality.')
            })
            .finally(() => {
                setIsLoading(false);
            });
    }
    return (
        <section className="reconcilation__verification__header">
            {['pdf', 'xlsx', 'xlsb', 'xls'].includes(getExtension) &&
                <button disabled={disabledState} className="reconcilation__verification__action flex__item__header" onClick={AnotherMethod}>
                    Another Method
                </button>
            }
            <button disabled={disabledState} className="reconcilation__verification__action flex__item__header" onClick={() => navigate("/")}>
                Home
            </button>
            <button disabled={disabledState} className="reconcilation__verification__action flex__item__header" onClick={() => navigate("/upload")}>
                Reupload
            </button>
        </section>
    )
}

export default RecoHeaderButton